module.exports = __webpack_public_path__ + "static/frame-12-76d929dbe97b8aaf02cc76fb8fdb3c3d.png";